<template>
  <div class="container-flex pb-4">
    <div class="home-top pt-5 pb-5">
      <h1 class="mb-0 pb-0">BuildIT with ObserveIT</h1>
      <div class="site-intro">Learn to build powerful integrations</div>
      <div class="site-intro"> with the ObserveIT API.</div>
      <p class="site-intro">Comprehensive guides to get you going quickly</p>
      <router-link class="btn btn--primary" :to="'/article/1LmvF1OwWMQS2M8KkQAmAA'">Getting Started</router-link>
      <a class="btn btn--primary" href="slack://channel?id=GGT0CA9GB&team=T7R89HX3Q">Q&A Community</a>
    </div>
      <div class=" home-bottom pt-4">
        <div class="row justify-content-md-center mr-0">
          <div class="col-lg-7">
            <div class="pt-4">
              <SpotlightList/>
            </div>
          </div>
          <div class="col-auto">
            <div class="pt-4">
              <UseCaseList/>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
 import '@/compiled-icons'

 // @ is an alias to /src
 import SpotlightList from '@/components/SpotlightList.vue'
 import UseCaseList from '@/components/UseCaseList.vue'

 export default {
   name: 'home-top',
   components: {
     SpotlightList,
     UseCaseList
   },
   metaInfo: {
     title: 'Home'
   }
 }
</script>

<style>
 .home-top {
     color: #002330;
     background-color: #bbb;
     text-align: center;
 }

 /* recommended css code for vue-svgicon */
 .svg-icon {
     display: inline-block;
     width: 16px;
     height: 16px;
     color: inherit;
     vertical-align: middle;
     stroke: currentColor;
 }

 .svg-fill {
     fill: currentColor;
     stroke: none;
 }

 .svg-up {
     /* default */
     transform: rotate(0deg);
 }

 .svg-right {
     transform: rotate(90deg);
 }

 .svg-down {
     transform: rotate(180deg);
 }

 .svg-left {
     transform: rotate(-90deg);
 }

 body {
     background-color: white;
     font-family: 'Open Sans', sans-serif;
     font-size: 12px;

 }

 .btn--primary {
     font-family: 'Open Sans', sans-serif;
     font-size: 16px;
     font-weight: 600;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
     text-align: center;
     display: inline-block;
     margin: 10px;
     padding: 18px 35px;
     color: white;
     background-color: #f1582b;
     border-radius: 50px;
     -webkit-border-radius: 50px;
 }
 .btn--primary:hover  {
     background-color: #ff8456;
     color: white;
 }

 .section-title {
     font-family: 'Titillium Web', sans-serif;
     color: #e4522a;
     text-align: left;
     font-size: 24px;
     font-weight: 600;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
     padding-bottom: 0.8em;
     border-bottom: 2px solid #00a1c8;
     margin-bottom: 1em;
 }

 .site-intro {
     font-size: 24px;
     font-weight: normal;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
     text-align: center;
 }

</style>
